import {
  APPLICANT_VERIFICATION_ADD_INCOME,
  APPLICANT_VERIFICATION_ADD_EMAIL_VERIFICATION,
  APPLICANT_VERIFICATION_VERIFY_EMAIL,
  APPLICANT_VERIFICATION_REQUEST,
  APPLICANT_VERIFICATION_SUCCESS,
  APPLICANT_VERIFICATION_FAILURE
} from "@/store/types";

import axios from "axios";

const baseUrl = process.env.VUE_APP_BACKEND_HOST;

const state = {
  isLoading: false,
  verification: null,
  error: null
};

const getters = {
  isApplicantLoading: state => state.isLoading,
  getApplicantVerification: state => state.verification
};

const actions = {
  [APPLICANT_VERIFICATION_ADD_INCOME]: (
    { commit },
    { income_skipped, token }
  ) => {
    return new Promise((resolve, reject) => {
      commit(APPLICANT_VERIFICATION_REQUEST);

      const payload = {};

      if (token) {
        payload.token = token;
      } else {
        payload.income_skipped = income_skipped;
      }

      axios
        .post(`${baseUrl}/api/verify/v1/verifications/add_income/`, payload)
        .then(resp => {
          commit(APPLICANT_VERIFICATION_SUCCESS, {});
          resolve(resp);
        })
        .catch(err => {
          commit(APPLICANT_VERIFICATION_FAILURE, err);
          reject(err);
        });
    });
  },
  [APPLICANT_VERIFICATION_ADD_EMAIL_VERIFICATION]: (
    { commit },
    { email_skipped, email }
  ) => {
    return new Promise((resolve, reject) => {
      commit(APPLICANT_VERIFICATION_REQUEST);
      const payload = {};

      if (email) {
        payload.email = email;
      } else {
        payload.email_skipped = email_skipped;
      }

      axios
        .post(
          `${baseUrl}/api/verify/v1/verifications/add_email_verification/`,
          payload
        )
        .then(resp => {
          commit(APPLICANT_VERIFICATION_SUCCESS, {});
          resolve(resp);
        })
        .catch(err => {
          commit(APPLICANT_VERIFICATION_FAILURE, err);
          reject(err);
        });
    });
  },
  [APPLICANT_VERIFICATION_VERIFY_EMAIL]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(APPLICANT_VERIFICATION_REQUEST);

      axios.defaults.headers.common["Authorization"] = token;

      axios
        .post(`${baseUrl}/api/verify/v1/verifications/verify_email/`)
        .then(resp => {
          commit(APPLICANT_VERIFICATION_SUCCESS, {});
          resolve(resp);
        })
        .catch(err => {
          commit(APPLICANT_VERIFICATION_FAILURE, err);
          reject(err);
        });
    });
  }
};

const mutations = {
  [APPLICANT_VERIFICATION_REQUEST]: state => {
    state.isLoading = true;
  },
  [APPLICANT_VERIFICATION_SUCCESS]: (state, { verification }) => {
    state.isLoading = false;

    if (verification) state.verification = verification;
  },
  [APPLICANT_VERIFICATION_FAILURE]: (state, error) => {
    state.isLoading = false;

    if (error) state.error = error;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
